export default {
  'bill.account': 'Billing Account',
  'bill.cycle': 'Bill Cycle',
  'bill.customerName': 'Customer Name',
  'bill.profileID': 'Profile ID',
  'bill.customerAddress': 'Customer Address',
  'bill.number': 'Bill Number',
  'bill.dueDate': 'Due Date',
  'bill.paymentsReceived': 'Payments Received',
  'bill.currentMonthCharges': 'Current Month Charges',
  'bill.vatregNo': 'VAT REG NO',
  'bill.accountNumber': 'Account Number',
  'bill.billPeriod': 'Bill Period',
  'bill.adjustments': 'Adjustments',
  'bill.balanceCarriedForward': 'Balance Carried Forward',
  'bill.totalAdvancePayment': 'Total Advance Payment',
  'bill.totalDue': 'Total Due',
  'bill.summary': 'Summary Of Current Change',
  'bill.totalCharges': 'Total Charges',
  'bill.totalTax': 'Total Tax',
  'bill.totalAmount': 'Total Amount',
  'bill.payment': 'Payment',
  'bill.download': 'Download',
  'bill.momo': 'MoMoAcctNO',
  'bill.momo.placeHoloder': 'Please input MoMoAcctNO',
  'bill.sms.captcha': 'SMS Captcha',
  'bill.sms.captcha.placeHoloder': 'Please input SMS Captcha',
  'bill.pay': 'Pay',
  'bill.pay.complete': 'Complete Payment',
  'bill.pay.result': 'Payment result waiting',
  'bill.time': 'Count Down',
  'bill.validateVerification': 'Verification Code Sent Successfully!',
  'bill.isPayProgress': 'There is a current payment in progress.',
  'bill.isPayComplete': 'Has the payment been completed?',
  'bill.yes': 'Yes',
  'bill.no': 'No',
  'bill.paymentCancel': 'Payment Cancel',
  'bill.paymentAmount': 'Payment Amount',
  'bill.mustBeNumericAndMinimumPayment': 'Must be numeric and minimum payment RM{minAmountData}.00',
  'bill.lockValid':
    'There is a payment in progress that you initiated. \nWould you like to cancel and make a new payment?',
};
